import React, { useRef } from 'react';
import { Button, useToasts } from '@applyboard/crystal-ui';
import { DownloadOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker, useTranslation } from '@applyboard/ui-utils';
import { QrCode } from './QRCode';

type QrCodeGroupProps = {
  qrCodeUrl: string;
  label: string;
  eventTrackingData?: { event: string; data?: Record<string, unknown> };
};

const QrCodeGroup = (props: QrCodeGroupProps) => {
  const { qrCodeUrl, eventTrackingData, label } = props;
  const toasts = useToasts();
  const { t } = useTranslation();
  const qrCodeRef = useRef<{ download: () => Promise<string | null> }>();
  const { trackEvent } = useEventTracker();
  return (
    <React.Fragment>
      <QrCode ref={qrCodeRef} ariaLabel={label} url={qrCodeUrl}></QrCode>
      <Button
        emphasis="highlighted"
        intent="primary"
        size="md"
        leadIcon={DownloadOutlineIcon}
        onClick={async () => {
          const dataUrl = await qrCodeRef?.current?.download?.();
          if (dataUrl) {
            const a = document.createElement('a');
            a.href = dataUrl;
            a.download = 'qr-code.png';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else {
            toasts.negative(new Error(t('hub.qrCode.downloadError')));
          }
          if (eventTrackingData) {
            trackEvent(eventTrackingData);
          }
        }}
      >
        {t('hub.qrCode.download')}
      </Button>
    </React.Fragment>
  );
};

export default QrCodeGroup;
